import * as React from "react"
import * as Conf from "../../../configuration"
import * as CommonUtils from "../../utils"
import { bodyW } from "../../pptx-configuration/constants"

export default class ExpensesComparaisonTable extends React.Component<Props> {
    private readonly LABEL_CELL_WIDTH: number
    private readonly VALUE_CELL_WIDTH: number
    private yearHeader: YearHeader[];

    constructor(props: Readonly<Props>) {
        super(props)
        this.LABEL_CELL_WIDTH = CommonUtils.toInches(6.3);
        this.VALUE_CELL_WIDTH = (bodyW - this.LABEL_CELL_WIDTH) / 5;
        this.yearHeader = [];
        this.buildYearHeader(this.props.currentYear);
    }

    buildYearHeader(currentYear: number) {
        this.yearHeader.push({
            year: currentYear - 2,
            isReal: true,
            libelle: "Réalisations " + (currentYear - 2),
        })
        this.yearHeader.push({
            year: currentYear - 1,
            isReal: true,
            libelle: "Réalisations " + (currentYear - 1),
        })
        this.yearHeader.push({
            year: currentYear,
            isReal: true,
            libelle: "Prévisions " + (currentYear),
        })
        this.yearHeader.push({
            year: currentYear,
            isReal: false,
            libelle: "Réalisations " + (currentYear),
        })
        this.yearHeader.push({
            year: currentYear,
            isReal: false,
            libelle: "Variation Prévisions " + (currentYear) + "/ Réalisations " + (currentYear) + " (%)",
        })
    }

    render() {
        const tableConf = this.props.tableConfiguration

        return <table id={this.props.id}>
            <thead>
                <tr>
                    <th data-pptx-width={this.LABEL_CELL_WIDTH}
                        style={{ ...tableConf.header }}></th>

                    {this.yearHeader.map((y, yi) =>
                        <th data-pptx-width={this.VALUE_CELL_WIDTH}
                            key={yi}
                            style={{ ...tableConf.header }}>{y.libelle}</th>
                    )}
                </tr>
            </thead>
            {this.renderExpenseTBody()}
        </table>
    }

    private getDisplayedValue(value: number, type?: RowType, key?: number): React.ReactText {
        const locale = this.props.locale

        if ("percentage" === type) {
            const formatter = new Intl.NumberFormat(locale, { style: "percent" })
            return formatter.format(value)
        }

        const currency = this.props.currency
        const roundness = this.props.roundness

        return CommonUtils.formatCurrency(locale, currency, value, roundness)
    }

    private getRowBaseStyle(row: TableRow): React.CSSProperties {
        if (isSubtotalTableRow(row)) return this.props.tableConfiguration.subtotal
        if (isTotalTableRow(row)) return this.props.tableConfiguration.total
        return this.props.tableConfiguration.common
    }

    private renderExpenseTBody(): React.ReactNode {
        const rows: TableRow[] = [];

        this.props.expenceTableDatas.forEach(chapter => {
            if (chapter.chapitreLibelle != "" && !CommonUtils.isArrayAllValuesZero(chapter.values)) {
                rows.push({
                    label: chapter.chapitreNumber + " - " + chapter.chapitreLibelle,
                    values: chapter.values
                });
            }
        })

        return <tbody>
            {rows.map(
                (row, rowIndex) =>
                    this.props.enableHideZeroLines ? CommonUtils.isArrayAllValuesZero(row.values) === false && this.renderRow(row, rowIndex) : this.renderRow(row, rowIndex)
            )}
        </tbody>
    }

    private renderRow(row: TableRow, key?: number): React.ReactNode {
        const years = this.props.years

        const conf = this.props.tableConfiguration
        const baseStyle: React.CSSProperties = this.getRowBaseStyle(row)
        const grey: React.CSSProperties = {
            backgroundColor: '#bccad1'
        }
        const greyStyle: React.CSSProperties = { ...baseStyle, ...grey }

        return <tr key={key}>
            <td style={{ ...baseStyle }}>{row.label}</td>
            {years.map((_y, yearIndex) => {
                const value = row.values[yearIndex]
                if (yearIndex == 2 || yearIndex == 3) {
                    return <td key={yearIndex} style={{ ...greyStyle, ...conf.numeric }}>
                        {this.getDisplayedValue(value, row.type, yearIndex)}
                    </td>
                } else if (yearIndex == 4) {
                    return <td key={yearIndex} style={{ ...baseStyle, ...conf.numeric }}>
                        {this.getDisplayedValue(value, "percentage", yearIndex)}
                    </td>
                } else {
                    return <td key={yearIndex} style={{ ...baseStyle, ...conf.numeric }}>
                        {this.getDisplayedValue(value, row.type, yearIndex)}
                    </td>
                }
            })}
        </tr>
    }
}

export interface Props {
    expenceTableDatas: ChapterRow[];
    currentYear: number;
    id: string;
    currency: string;
    locale: string;
    roundness: Conf.RoundnessValue
    enableHideZeroLines: boolean;
    tableConfiguration: Conf.TableConfiguration;
    years: number[];
}

function isSubtotalTableRow(row: TableRow): row is SubtotalTableRow {
    return undefined !== (row as SubtotalTableRow).subtotal
}

function isTotalTableRow(row: TableRow): row is TotalTableRow {
    return undefined !== (row as TotalTableRow).total
}

interface BaseTableRow {
    label: string
    values: number[]
    type?: RowType
}

interface SubtotalTableRow extends BaseTableRow {
    subtotal: boolean
}

interface TotalTableRow extends BaseTableRow {
    total: boolean
}

interface YearHeader {
    year: number;
    isReal: boolean;
    libelle: string;
}

type RowType = "currency" | "duration" | "percentage"

type TableRow = BaseTableRow | SubtotalTableRow | TotalTableRow

export interface ChapterRow {
    chapitreNumber: string;
    chapitreLibelle: string;
    values: number[]
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/comparaison-generator/expense-operation-comparaison-table.tsx